import styled from 'styled-components';
import { Colors, ContentSpacing } from '@estee/elc-base-theme';
import { PlusIcon, MinusIcon } from '@estee/elc-icons';
import Tooltip from '~sharedComponents/Tooltip/Tooltip';

const iconCss = `
    height: 16px;
    width: 16px;
    stroke: ${Colors.black};
    cursor: default;
    pointer-events: none;
`;

const buttonCss = `
    align-items: center;
    border: 0;
    background: transparent;
    width: 32px;
    height: 32px;
    cursor: pointer;
    display: flex;
    padding: 0 ${ContentSpacing.space8};

    &:disabled,
    &.disabled {
        cursor: not-allowed;
    }

    color: ${Colors.black};
`;

export const PlusIconStyled = styled(PlusIcon)<React.HTMLProps<HTMLButtonElement>>`
    ${iconCss};
`;

export const MinusIconStyled = styled(MinusIcon)<React.HTMLProps<HTMLButtonElement>>`
    ${iconCss};
`;

export const SpinnerSelectorWrapper = styled.div`
    border: 1px solid;
    display: inline-flex;
    border-radius: ${ContentSpacing.space4};
    border-color: ${Colors.primary300};
`;

export const ActionButton = styled.button`
    ${buttonCss};
`;

export const StyledTooltip = styled(Tooltip)`
    ${buttonCss};
`;

export const ContentDataWrapper = styled.div`
    border-left: 1px solid;
    border-right: 1px solid;
    padding: 6px 14px;
    flex-grow: 2;
    border-color: ${Colors.primary300};
`;
